// Thin client-side analytics wrapper.
//
// posthog-js is initialized by the shared application/login packs. This wrapper
// keeps callers isolated from analytics failures and from pages where PostHog is
// intentionally disabled because no project token was exposed.
//
// Use trackEvent() liberally. It is safe to call on every interesting user
// action; failures are swallowed so analytics never break a page.
//
// Default events the v2 workout builder emits (others can be added freely —
// the four below are the launch-critical ones called out in the spec):

export const EVENTS = Object.freeze({
  OPENED:          'wbv2_opened',
  SAVED:           'wbv2_saved',
  EXERCISE_ADDED:  'wbv2_exercise_added',
  LINK_TOGGLED:    'wbv2_link_toggled',
  FORM_EDIT_SCOPE_CHOSEN: 'form_edit_scope_chosen',
  // Coach first-run product tour (CC-1034).
  ONBOARDING_TOUR_STARTED:     'onboarding_tour_started',
  ONBOARDING_TOUR_STEP_VIEWED: 'onboarding_tour_step_viewed',
  ONBOARDING_TOUR_SKIPPED:     'onboarding_tour_skipped',
  ONBOARDING_TOUR_COMPLETED:   'onboarding_tour_completed',
  ONBOARDING_TOUR_REPLAYED:    'onboarding_tour_replayed',
});

export function trackEvent(event, props = {}) {
  if (!event) return;
  try {
    if (typeof window === 'undefined') return;
    const ph = window.posthog;
    if (ph && typeof ph.capture === 'function') {
      ph.capture(event, props);
      return;
    }
    // Optional debug trail — visible only when the localStorage flag is set.
    if (typeof localStorage !== 'undefined' && localStorage.getItem('cc_analytics_debug') === '1') {
      // eslint-disable-next-line no-console
      console.debug('[analytics:noop]', event, props);
    }
  } catch (_) {
    // Never let telemetry crash the page.
  }
}

// Convenience for tests + future consumers who want a sane default object.
export default { EVENTS, trackEvent };
